/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* Services */

/**
 * Renders the Doubts Clarify content component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} SDoubts Clarify content component
 */

const DoubtsClarify = ({ section, region, language, csrData }) => {
  const moduledata = section?.sectionContent;
  return (
    <Box
      as="div"
      fontFamily="FedraSansStd-book"
      width={{ base: '90%', sm: '90%', md: '400px', lg: '400px' }}
      m="0 auto 50px auto"
      className="contactus"
    >
      <SectionTitle titleObj={moduledata[0]} />
      <Box className="event-text" mt="-15px">
        <StructuredTextParser
          str={render(moduledata[1]?.body)}
          region={region}
          lang={language}
          mt="0"
          mb="50px"
          textAlign="center"
        />
      </Box>
    </Box>
  );
};

export default DoubtsClarify;
